import { render, staticRenderFns } from "./SaveNotificationTemplateModal.vue?vue&type=template&id=31b5d6ca&scoped=true&"
import script from "./SaveNotificationTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SaveNotificationTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveNotificationTemplateModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SaveNotificationTemplateModal.vue?vue&type=style&index=1&id=31b5d6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b5d6ca",
  null
  
)

export default component.exports